<template>
  <div class="modal-overlay">
  
      <div class="modal-box" :class="[mode]">

      <component
        :is="currentComponent"
        :serviceId="serviceId"
        :service="service"
        :actionType="actionType"
        @switchMode="switchMode"
        @close="$emit('close')"
        @loginSuccess="$emit('loginSuccess', $event)"
      />

    
      <button class="close-btn" @click="$emit('close')" aria-label="Close">
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none">
          <path d="M6 6L18 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
          <path d="M18 6L6 18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"/>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
import LoginModal from "./LoginModal.vue";
import RegisterModal from "./registerModal.vue";
import ForgotModal from "./ForgetModal.vue";
import EmailLinkModal from "./EmailLinkModal.vue";
import sendResponseLoginModal from "./sendResponseLoginModal.vue";
export default {
  props: {
    mode: { type: String, required: true }, 
    serviceId: { type: String, default: null },
    service: { type: Object, default: null },
    actionType: { type: String, default: '' }

  },

  components: {
    LoginModal,
    RegisterModal,
    ForgotModal,
    EmailLinkModal,
    sendResponseLoginModal
 
  },

  computed: {

    currentComponent() {
 
      if (this.mode === "register") return "RegisterModal";
      if (this.mode === "forgot") return "ForgotModal";
      if (this.mode === "emailLink") return "EmailLinkModal";
      if (this.mode === "sendResponseLogin") return "sendResponseLoginModal";
      return "LoginModal";
    },

 
  },
  methods: {
    switchMode(type) {
      this.$emit("switchMode", type);
    },
 

  },
};
</script>

<style>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(6px);
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.modal-box {
  background: white;
  position: relative;
  z-index: 10000;
  border-radius: 16px;
  width: 420px;
  max-width: calc(100vw - 32px);
  /* Keep the whole box (close X at top, submit at bottom) inside the safe
     viewport on notched phones; the overlay centers it in what's left. */
  max-height: calc(
    100dvh - 32px - env(safe-area-inset-top, 0px) -
      env(safe-area-inset-bottom, 0px)
  );
  overflow-y: auto;
  padding: 0;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2), 0 4px 16px rgba(0, 0, 0, 0.1);
}

.row {
  display: flex;
  gap: 10px;
}

.row-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.main-btn {
  width: 100%;
  background: var(--color-primary);
  color: white;
  padding: 10px;
  border-radius: 6px;
  margin-top: 10px;
  cursor: pointer;
}

.switch-text {
  text-align: center;
  margin-top: 10px;
}

.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.25);
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  z-index: 10001;
  transition: background 0.2s;
  padding: 0;
}

.close-btn:hover {
  background: rgba(255, 255, 255, 0.4);
}
</style>
